import { COLOR_LIST } from "../config"

function getLabelOptions () {
    return {
        show: true,
        position: "top",
        distance: 10,
        align: "center",
        verticalAlign: "middle",
        rotate: 0,
        // formatter: (arg) => {
        //     console.log(arg, "arg")
        // },
        fontSize: 14,
        color: "#333",
        // rich: {
        //     name: {}
        // }
    }
}

export function defaultSeriesSettings () {
    return {
        type: "bar",
        barGap: 0,
        label: getLabelOptions(),
        seriesLayoutBy: "column",
        emphasis: {
            focus: "series"
        },
        barWidth: '35px'
    }
}

export default function defaultSettings () {
    return {
        color: COLOR_LIST,
        grid: {
            bottom: "40"
        },
        title: {
            text: "BarChart",
            left: "center",
            top: "0",
            textStyle: {
                fontSize: 18,
                color: "#333",
                fontWeight: 600
            }
        },
        tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0,0,0, .4)",
            textStyle: {
                color: "#fff"
            },
            axisPointer: {
                type: "shadow"
            }
        },
        dataZoom: [
            {
                xAxisIndex: 0, // 这里是从X轴的0刻度开始
                show: true, // 是否显示滑动条，不影响使用
                type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                startValue: 0, // 从头开始。
                endValue: 7, // 一次性展示6个
                height: 8, // 组件高度
                bottom: 0,
                zoomLock: true,
                showDataShadow: false, // 是否显示数据阴影 默认auto
                showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
                realtime: true, // 是否实时更新
                filterMode: "filter",
                moveOnMouseMove: true,
                maxValueSpan: 7,
                minValueSpan: 7,
                moveHandleSize: 0,
                brushSelect: false, // 刷选功能，设为false可以防止拖动条长度改变 ************（这是一个坑）
            },
        ],
        legend: {
            orient: "horizontal", /* vertical */
            left: "center",
            top: 10,
            icon: "roundRect",
            padding: 10,
            textStyle: {
                fontSize: 14
            }
        },
        xAxis: [
            {
                type: "category",
                axisTick: { show: false },
                axisLabel: {
                    fontSize: 14
                }
            }
        ],
        yAxis: [
            {
                type: "value",
                axisLabel: {
                    fontSize: 14
                }
            }
        ],
        series: [
            defaultSeriesSettings()
        ]
    }
}
